import { render, staticRenderFns } from "./SubSnapshotDetail.vue?vue&type=template&id=362cedd0&"
import script from "./SubSnapshotDetail.vue?vue&type=script&lang=js&"
export * from "./SubSnapshotDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports